var LAYOUT_DIRECTION = {
  LEFT_TO_RIGHT: false,
  RIGHT_TO_LEFT: true
};
export default LAYOUT_DIRECTION;